import React from 'react';
import { Icon } from '@iconify/react';
import AppButton from './AppButton';
import AppSpinner from './AppSpinner';
import cx from './cx';
import '../../styles/app-ui.scss';

const AppEmptyState = ({
  loading = false,
  message = 'Aucun résultat.',
  description = '',
  actions = [],
  icon = 'mdi:table-large-remove',
  className = '',
}) => {
  if (loading) {
    return (
      <div className={cx('app-empty-state', 'app-empty-state--loading', className)} role="status">
        <AppSpinner size="sm" centered={false} variant="secondary" />
        <p className="app-empty-state__title">Chargement…</p>
      </div>
    );
  }

  return (
    <div className={cx('app-empty-state', className)}>
      {icon ? <Icon icon={icon} className="app-empty-state__icon" aria-hidden /> : null}
      <p className="app-empty-state__title">{message}</p>
      {description ? <p className="app-empty-state__description">{description}</p> : null}
      {actions.length > 0 && (
        <div className="app-empty-state__actions">
          {actions.map((action) => (
            <AppButton
              key={action.key || action.label}
              size="sm"
              variant={action.variant === 'primary' ? 'primary' : 'outline-secondary'}
              icon={action.icon}
              onClick={action.onClick}
              disabled={action.disabled}
            >
              {action.label}
            </AppButton>
          ))}
        </div>
      )}
    </div>
  );
};

export default AppEmptyState;
